/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { DescriptionPage_IndustryCertificationQualificationType as IndustryCertificationQualificationType } from '__generated__/graphql-types';

import { Button, Typography2 } from '@coursera/cds-core';
import { HonorsAssignmentIcon } from '@coursera/cds-icons';

import { getHeadingStyle } from 'bundles/unified-description-page-common/components/modules/product-overview/details/Details';
import Modal, { useModal } from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

import _t from 'i18n!nls/xdp';

type Props = {
  productType: string;
  industryCetificationQualification: IndustryCertificationQualificationType;
  industryCertificationName: string;
};

const styles = {
  itemTitle: css`
    padding: var(--cds-spacing-100) 0;
  `,
  icon: css`
    display: block;
  `,
  button: css`
    padding: 0;
    margin-left: 0;

    /* set vertical-align to unset to vertically center the button within the "Subtitles" line */
    vertical-align: unset;

    :hover {
      background: transparent;
    }
  `,
};

const IndustryCertificationDetailItem = ({
  productType,
  industryCetificationQualification,
  industryCertificationName,
}: Props) => {
  const { enableXDPRedesignPhase1 } = useXDPRedesignPhase1Data();
  const { isModalOpen, setModalOpen } = useModal();

  return (
    <React.Fragment>
      <HonorsAssignmentIcon size="large" css={styles.icon} />
      <Typography2 variant={getHeadingStyle(enableXDPRedesignPhase1)} css={styles.itemTitle} component="div">
        {_t('Industry certification')}
      </Typography2>
      <Button
        variant="ghost"
        size="small"
        edgeAlign="start"
        onClick={setModalOpen}
        css={styles.button}
        aria-label={_t('Learn more about the industrcy certification')}
      >
        {_t('Learn more')}
      </Button>
      <Modal open={isModalOpen} setOpen={setModalOpen} header={_t('Industry certification')}>
        {industryCetificationQualification === IndustryCertificationQualificationType.Qualified
          ? _t('This #{productType} helps prepare you for the industry-recognized #{industryCertificationName}.', {
              productType,
              industryCertificationName,
            })
          : _t(
              'This #{productType} qualifies you for learning hours towards the industry-recognized #{industryCertificationName}.',
              { productType, industryCertificationName }
            )}
      </Modal>
    </React.Fragment>
  );
};

export default IndustryCertificationDetailItem;
